import { render, staticRenderFns } from "./InviteFriendForm.vue?vue&type=template&id=7202e4c0&scoped=true&"
import script from "./InviteFriendForm.vue?vue&type=script&lang=ts&"
export * from "./InviteFriendForm.vue?vue&type=script&lang=ts&"
import style0 from "./InviteFriendForm.vue?vue&type=style&index=0&id=7202e4c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7202e4c0",
  null
  
)

export default component.exports